<div class="client-dashboard-title-buttons-container">
  <div
    id="edit-button"
    (click)="onEditClick()"
    *ngIf="isEdit"
    class="action-item"
    role="button"
    tabindex="0"
    aria-label="Edit"
  >
    <svg
      class="icon-style"
      xmlns="http://www.w3.org/2000/svg"
      height="40px"
      viewBox="0 -960 960 960"
      width="40px"
      fill="#f2893e"
      aria-hidden="true"
    >
      <path
        d="M200-400q-17 0-28.5-11.5T160-440q0-17 11.5-28.5T200-480h200q17 0 28.5 11.5T440-440q0 17-11.5 28.5T400-400H200Zm0-160q-17 0-28.5-11.5T160-600q0-17 11.5-28.5T200-640h360q17 0 28.5 11.5T600-600q0 17-11.5 28.5T560-560H200Zm0-160q-17 0-28.5-11.5T160-760q0-17 11.5-28.5T200-800h360q17 0 28.5 11.5T600-760q0 17-11.5 28.5T560-720H200Zm320 520v-66q0-8 3-15.5t9-13.5l209-208q9-9 20-13t22-4q12 0 23 4.5t20 13.5l37 37q8 9 12.5 20t4.5 22q0 11-4 22.5T863-380L655-172q-6 6-13.5 9t-15.5 3h-66q-17 0-28.5-11.5T520-200Zm263-184 37-39-37-37-38 38 38 38ZM580-220h38l121-122-18-19-19-18-122 121v38Zm0 0v-38l122-121 37 37-121 122h-38Z"
      />
    </svg>
    <p class="text-style" translate>Edit</p>
  </div>
  <div
    id="full-view-button"
    (click)="onFullViewClick()"
    *ngIf="isFullView"
    class="action-item"
    role="button"
    tabindex="0"
    aria-label="Full View"
  >
    <svg
      class="icon-style"
      xmlns="http://www.w3.org/2000/svg"
      height="40px"
      viewBox="0 -960 960 960"
      width="40px"
      fill="#f2893e"
      aria-hidden="true"
    >
      <path
        d="m156-100-56-56 124-124H120v-80h240v240h-80v-104L156-100Zm648 0L680-224v104h-80v-240h240v80H736l124 124-56 56ZM120-600v-80h104L100-804l56-56 124 124v-104h80v240H120Zm480 0v-240h80v104l124-124 56 56-124 124h104v80H600Z"
      />
    </svg>
    <p class="text-style" translate>Full View</p>
  </div>
  <div
    id="history-button"
    (click)="onHistoryClick()"
    *ngIf="isHistory"
    class="action-item"
    role="button"
    tabindex="0"
    aria-label="History"
  >
    <svg
      class="icon-style"
      xmlns="http://www.w3.org/2000/svg"
      height="40px"
      viewBox="0 -960 960 960"
      width="40px"
      fill="#f2893e"
      aria-hidden="true"
    >
      <path
        d="M200-200v-560 203-3 360Zm0 80q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h480l160 160v147q-19-9-39-15t-41-9v-89L646-760H200v560h252q7 22 16.5 42t22.5 38H200Zm242-126q-1-9-1.5-17.5T440-281q0-54 20-104t58-89q-9-3-18.5-4.5T480-480q-50 0-85 35t-35 85q0 39 22.5 70.5T442-246ZM720-80q-83 0-141.5-58.5T520-280q0-83 58.5-141.5T720-480q83 0 141.5 58.5T920-280q0 83-58.5 141.5T720-80Zm20-208v-112h-40v128l87 87 28-28-75-75ZM240-560h360v-160H240v160Z"
      />
    </svg>
    <p class="text-style" translate>History</p>
  </div>
  <div
    id="report-button"
    (click)="onReportClick()"
    *ngIf="isReport"
    class="action-item"
    role="button"
    tabindex="0"
    aria-label="Report"
  >
    <svg
      class="icon-style"
      xmlns="http://www.w3.org/2000/svg"
      height="40px"
      viewBox="0 -960 960 960"
      width="40px"
      fill="#f2893e"
      aria-hidden="true"
    >
      <path
        d="M320-440h320v-80H320v80Zm0 120h320v-80H320v80Zm0 120h200v-80H320v80ZM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H240Zm280-520v-200H240v640h480v-440H520ZM240-800v200-200 640-640Z"
      />
    </svg>
    <p class="text-style" translate>Report</p>
  </div>
  <div
    id="new-button"
    (click)="onNewClick()"
    *ngIf="isNew"
    class="action-item"
    role="button"
    tabindex="0"
    aria-label="New Entry"
  >
    <svg
      class="icon-style"
      xmlns="http://www.w3.org/2000/svg"
      height="40px"
      viewBox="0 -960 960 960"
      width="40px"
      fill="#f2893e"
      aria-hidden="true"
    >
      <path
        d="M440-280h80v-160h160v-80H520v-160h-80v160H280v80h160v160Zm40 200q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
      />
    </svg>
    <p class="text-style" translate>New Entry</p>
  </div>
</div>
